export const actionTypes = {
  GENERAL: 'כללי',
  PAYMENTS: 'תשלומים',
  INVOICES: 'חשבוניות'
}